<ub-card [variant]="bookingItem.workflow.state === 'published' ? 'success' : 'warn'" [rounded]="true"
  [dividers]="false">
  <h3 title><a [routerLink]="[bookingItem.doc._id, 'view']">{{ bookingItem.doc.name ?? bookingItem.doc._id }}</a></h3>
  <div content>
    @if (bookingOption$ | async; as bookingItemOption) {
      <div>
        @if (bookingItemOption.summary.openOptions) {
          <ub-label label="Booking status" text="OPEN" variant="success" i18n-label i18n-text></ub-label>
        }
        @if (!bookingItemOption.summary.openOptions) {
          <ub-label label="Booking status" text="CLOSED" variant="" i18n-label i18n-text></ub-label>
        }
        <ub-label label="State" text="{{ bookingItem.workflow.title }}" i18n-label></ub-label>
        @if (bookingItemOption.summary.bookingDates?.min) {
          <ub-label label="Date" i18n-label>
            <span text>
              {{ bookingItemOption.summary.bookingDates | easDateRange: timezone:bookingItemOption.bookingDates?.timezone }}
            </span>
          </ub-label>
        }
        @if (bookingItemOption.summary.bookingWindow?.min) {
          <ub-label label="Booking window" i18n-label>
            <span text>
              {{ bookingItemOption.summary.bookingWindow | easDateRange: timezone:bookingItemOption.bookingWindow?.timezone }}
            </span>
          </ub-label>
        }
        @if (bookingItemOption.summary.openOptions) {
          <ub-label label="Open options" i18n-label>
            <span text>
              {{ bookingItemOption.summary.openOptions }}
            </span>
          </ub-label>
        }
        @if (bookingItemOption.summary.price.min !== null) {
          <ub-label label="Price" i18n-label>
            <span text>{{ bookingItemOption.summary.price| easPriceRange: bookingItemOption.summary.price.currency }}</span>
          </ub-label>
        }
      </div>
    }
    @if (bookingItem.doc.translationInfo) {
      <eas-translation-info-list [translationInfo]="bookingItem.doc.translationInfo">
      </eas-translation-info-list>
    }
  </div>
  <div actions>
    @if (buttons) {
      <eas-buttons-menu [buttons]="buttons"></eas-buttons-menu>
    }
  </div>
</ub-card>
